import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import BaseViewStore from 'base-viewstore';

export class ButtonViewStore extends BaseViewStore {

    @observable isClicked = false;
    @observable errorMessage = "";

    valid = true;
    value = 0;

    constructor(props) {
        super(props);
        
        if(this.props.form) {
            this.props.form.controls.push(this);
        }

        //this.validate();
    }

    // validation is a derivation
    @computed get invalid() {
        const invalid = {};
        return invalid;
    }  

    @action.bound save() {
    }

    @action.bound onClick(e) {
        if(this.isClicked) { return; }
        
        let form = this.props.form;
        if(!form) {
            return;
        }

        if(form.updating) {
            const self = this;
            setTimeout(function() {
                self.onClick(e);
            }, 50);
            return;
        }

        this.isClicked = true;

        if(this.props.contentModel.action == "commit-1" || this.props.contentModel.action == "commit-2" || this.props.contentModel.action == "commit-3" || this.props.contentModel.action == "commit-4") {
            this.disableFields();
            
            let total = 0;
            let complete = 0;
            for(let i = 0; i < form.controls.length; ++i) {
                if(form.controls[i].constructor.name != "ButtonViewStore" || form.controls[i].props.contentModel.id == "ProgressButton_996") {
                    continue;
                }
                if(form.controls[i].isClicked) { complete += 1; }
                total += 1;
            }
            if(complete >= total) {
              setTimeout(function() {
                  form.isSubmitting = true;
                  form.update();
              }, 200);
            }
        }
        else {
            form.isSubmitting = true;
        }
        if(form.props.contentModel.id.indexOf('activity_680096016') >= 0 && window.application.shell.needsStrategy) {
            window.application.shell.needsStrategy = false;
        }

        if(form.props.contentModel.id == "activity_917175720" || form.props.contentModel.id == "activity_917175720_2" || form.props.contentModel.id == "activity_917175720_3") {
            
            let set = {};
            set["G:FI_RES_BidStatusR1P1:" + window.application.dataModel.domainStore.context.team.num5] = -2;
            set["G:FI_RES_BidStatusR1P2:" + window.application.dataModel.domainStore.context.team.num5] = -2;
            set["G:FI_RES_BidStatusR2P1:" + window.application.dataModel.domainStore.context.team.num5] = -2;
            set["G:FI_RES_BidStatusR2P2:" + window.application.dataModel.domainStore.context.team.num5] = -2;
            window.simgate.updateData({
                path: window.application.dataModel.domainStore.context.team.pathId,
                set: set
            });

            for(let i = 0; i < form.controls.length; ++i) {
                if(form.controls[i].props.contentModel.id == "DropDownInputField_206" ||
                    form.controls[i].props.contentModel.id == "DropDownInputField_994" ||
                    form.controls[i].props.contentModel.id == "DropDownInputField_107" ||
                    form.controls[i].props.contentModel.id == "DropDownInputField_124") {
                    form.controls[i].value = -2;
                }
            }

            form.dbVariableStore["G:FI_RES_BidStatusR1P1:G"] = -2;
            form.dbVariableStore["G:FI_RES_BidStatusR1P2:G"] = -2;
            form.dbVariableStore["G:FI_RES_BidStatusR2P1:G"] = -2;
            form.dbVariableStore["G:FI_RES_BidStatusR2P2:G"] = -2;
        }

        form.update();
    }
    
    @action.bound update() {
        if(this.isClicked || this.props.form.props.contentModel.isSubmitted) {
            this.errorMessage = "";
            this.props.contentModel.disabled = true;
            return; 
        }
        
        const form = this.props.form;
        if(!form) { return; }
        
        this.props.contentModel.disabled = false;
        this.errorMessage = "";
        
        if(this.props.contentModel.id != "ProgressButton_244" && this.props.contentModel.id != "Round1Intro_Button" && this.props.contentModel.id != "Round2Intro_Button" && this.props.contentModel.id != "Round3Intro_Button" && window.application.shell.needsStrategy) {
          this.errorMessage = "You must finalize your strategy.";
          return;
        }

        if(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"] < 0 || this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream2:G"] < 0 || this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream3:G"] < 0) {
          this.errorMessage = "You have exceeded your budget.";
        }
        else if(this.props.contentModel.action == "commit-1" && parseFloat(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"]) < parseFloat(this.props.form.dbVariableStore["G:FI_RES_BlockExpenditureR1P1:G"])) {
          this.errorMessage = "Exploration may exceed budget.";
        }
        else if(this.props.contentModel.action == "commit-2" && parseFloat(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"]) < parseFloat(this.props.form.dbVariableStore["G:FI_RES_BlockExpenditureR1P2:G"])) {
          this.errorMessage = "Exploration may exceed budget.";
        }
        else if(this.props.contentModel.action == "commit-3" && parseFloat(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"]) < parseFloat(this.props.form.dbVariableStore["G:FI_RES_BlockExpenditureR2P1:G"])) {
          this.errorMessage = "Exploration may exceed budget.";
        }
        else if(this.props.contentModel.action == "commit-4" && parseFloat(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"]) < parseFloat(this.props.form.dbVariableStore["G:FI_RES_BlockExpenditureR2P2:G"])) {
          this.errorMessage = "Exploration may exceed budget.";
        }

        if(this.props.contentModel.id == "ProgressButton_996") {
          let total = 0;
          let complete = 0;
          for(let i = 0; i < form.controls.length; ++i) {
              if(form.controls[i].constructor.name != "ButtonViewStore" || form.controls[i] == this) {
                  continue;
              }
              if(form.controls[i].isClicked) { complete += 1; }
              total += 1;
          }
          if(complete < total) {
            this.errorMessage = complete + " of " + total + " explorations committed.";
          }
        }
        else if(this.props.contentModel.id == "ProgressButton_244") {
          const value = parseInt(form.dbVariableStore["G:FI_RES_SumCapitalAllocationPercent:G"]);
          let totalField = null;
          for(let i = 0; i < form.controls.length; ++i) {
              if(form.controls[i].props.contentModel.id == "NumberInputField_20") {
                  totalField = form.controls[i];
                  break;
              }
          }
          if(value != 100) {
              if(totalField != null) {
                  totalField.props.contentModel.value = totalField.value + "_FAKE";
                  totalField.valid = false;
              }
              this.errorMessage = "Total allocation % must equal 100%";
          }
          else {
              if(totalField != null) {
                  totalField.valid = true;
              }

              if(form.dbVariableStore["G:FI_DEC_Initiative1:G"] == form.dbVariableStore["G:FI_DEC_Initiative2:G"] && form.dbVariableStore["G:FI_DEC_Initiative1:G"] != 0) {
                  this.errorMessage = "You cannot select an initiative twice.";
              }
          }
        }
        else if(this.props.contentModel.id == "ProgressButton_178") {
          if(form.dbVariableStore["G:FI_RES_TransUnitsToRefineryR1P1:G"] > form.dbVariableStore["G:FI_TRANS_TotCapacityR1P1:G"] ||
          form.dbVariableStore["G:FI_RES_TransUnitsToRefineryR1P2:G"] > form.dbVariableStore["G:FI_TRANS_TotCapacityR1P2:G"] ||
          form.dbVariableStore["G:FI_RES_TransUnitsToRefineryR2P1:G"] > form.dbVariableStore["G:FI_TRANS_TotCapacityR2P1:G"] ||
          form.dbVariableStore["G:FI_RES_TransUnitsToRefineryR2P2:G"] > form.dbVariableStore["G:FI_TRANS_TotCapacityR2P2:G"]) {
            this.errorMessage = "Transportation cannot exceed capacity.";
          }
        }

        const variable = this.props.contentModel.variable;
        if(!this.props.form || !variable || (typeof (this.props.form.dbVariableStore[variable])) === 'undefined') {
            return;
        }

        this.value = this.props.form.dbVariableStore[variable];
        if(this.value == 1) {
            this.disableFields();
        }
        else {
            let dropdownField = null;
            
            if(this.props.contentModel.action == "commit-1") {
                for(let i = 0; i < form.controls.length; ++i) {
                    if(form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField18") {
                        form.controls[i].props.contentModel.disabled = false;
                    }
                    if(form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                        dropdownField = form.controls[i];
                    }
                }
            }
            else if(this.props.contentModel.action == "commit-2") {
                for(let i = 0; i < form.controls.length; ++i) {
                    if(form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField39") {
                        form.controls[i].props.contentModel.disabled = false;
                    }
                    if(form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                        dropdownField = form.controls[i];
                    }
                }
            }
            else if(this.props.contentModel.action == "commit-3") {
                for(let i = 0; i < form.controls.length; ++i) {
                    if(form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField61") {
                        form.controls[i].props.contentModel.disabled = false;
                    }
                    if(form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                        dropdownField = form.controls[i];
                    }
                }
            }
            else if(this.props.contentModel.action == "commit-4") {
                for(let i = 0; i < form.controls.length; ++i) {
                    if(form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField81") {
                        form.controls[i].props.contentModel.disabled = false;
                    }
                    if(form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                        dropdownField = form.controls[i];
                    }
                }
            }

            if(dropdownField) {
                if(this.props.form.dbVariableStore["G:FI_RES_RunExplorationR1P1:G"] != 1 && 
                   this.props.form.dbVariableStore["G:FI_RES_RunExplorationR1P2:G"] != 1 &&
                   this.props.form.dbVariableStore["G:FI_RES_RunExplorationR2P1:G"] != 1 &&
                   this.props.form.dbVariableStore["G:FI_RES_RunExplorationR2P2:G"] != 1) {
                    dropdownField.props.contentModel.disabled = false
                }
            }
        }
    }
    @action.bound disableFields() {
        this.props.contentModel.disabled = true;
        this.isClicked = true;
        this.value = 1;
        this.errorMessage = "";
        
        let form = this.props.form;
        if(!form) {
            return;
        }
        
        if(this.props.contentModel.action == "commit-1") {
            for(let i = 0; i < form.controls.length; ++i) {
                if(form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField18" || form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                    form.controls[i].props.contentModel.disabled = true;
                }
            }
        }
        else if(this.props.contentModel.action == "commit-2") {
            for(let i = 0; i < form.controls.length; ++i) {
                if(form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField39" || form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                    form.controls[i].props.contentModel.disabled = true;
                }
            }
        }
        else if(this.props.contentModel.action == "commit-3") {
            for(let i = 0; i < form.controls.length; ++i) {
                if(form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField61" || form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                    form.controls[i].props.contentModel.disabled = true;
                }
            }
        }
        else if(this.props.contentModel.action == "commit-4") {
            for(let i = 0; i < form.controls.length; ++i) {
                if(form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField81" || form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                    form.controls[i].props.contentModel.disabled = true;
                }
            }
        }
    }
}



export class ProgressButtonViewStore extends ButtonViewStore {
    
        @observable progress = 0;

        @action.bound lateUpdate() {
            const form = this.props.form;
        }
    }
    


// WEBPACK FOOTER //
// ./app_modules/form-control-activity/buttons/viewstore.js